/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/react-in-jsx-scope */
import { Alert, Box, Grid } from "@mui/material";
import { Formik } from "formik";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../../../components/common/new/InputField/InputField";
import Button from "../../../../components/common/Button";
import Toast from "../../../../components/common/Toast";
import AutoCompleteDropdown from "../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { MEMBER_PROFILE_CREATE } from "../../../../contants/formFields";
import { selectMemberProfile } from "../../../../redux/selectors/member";
import IntroductionFormApi from "../../../../services/api/introductionForm";
import Member from "../../../../services/api/member";
import { getOptions } from "../../../../utils";
import { debounce } from "../../../../utils/helper";
import Styles from "./MemberProfileForm.styles";
import { AlertStatus, PERMISSIONS } from "../../../../contants";
import useUserConfig from "../../../../hooks/useUserConfig";
import ProfilePictureModal from "../../../../components/common/new/ProfilePictureModal/ProfilePictureModal";
// import { getInitials } from "../../memberDetails/utlis";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
// import Typography from "../../../../components/common/new/Typography/Typography";
import { selectAllSIUsers } from "../../../../redux/selectors/user";
// import OrganizationStructure from "../../../../components/common/OrganizationStructure/OrganizationStructure";

/* ─── Shared card/section wrapper styles ─────────────────────────────────── */
const sectionCard = {
  background: "#fff",
  border: "1px solid #E8E9ED",
  borderRadius: "10px",
  padding: "20px 20px 16px",
  marginBottom: "14px",
  boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
};

const sectionTitle = {
  fontSize: "12px",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "#8F92A1",
  marginBottom: "14px",
};

function ProfileForm({
  values,
  handleChange,
  errors,
  setFieldValue,
  setCities,
  states,
  cities,
  countries,
  university,
  profession,
  // memberProfile,
  block,
  hasPermission,
  isLoading,
  isDistrictSi,
  isChapterSi,
  isHelpDesk,
  isHelpDeskAdmin,
  divisions,
  subDivisions,
  setSubDivisions,
  isNameChangeRestricted,
}) {
  const navigate = useNavigate();

  const onCancel = () => {
    navigate(-1);
  };

  return (
    <Box sx={{ padding: "2px 0 0" }}>
      {/* ── Section 1: Personal Info ── */}
      <Box style={sectionCard}>
        <div style={sectionTitle}>Personal Information</div>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <InputField
              label="Full Name"
              placeholder="Full Name.."
              name={MEMBER_PROFILE_CREATE.NAME}
              value={values[MEMBER_PROFILE_CREATE.NAME]}
              onChange={(e) => {
                const { value } = e.target;
                const regex = /^[A-Za-z ]*$/;
                if (regex.test(value)) {
                  if (value.startsWith(" ")) return;
                  if (value.trim().length === 0 && value.length > 0) return;
                  handleChange(e);
                }
              }}
              disabled={
                !hasPermission(PERMISSIONS.UPDATE_MEMBER_NAME) ||
                isNameChangeRestricted
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputField
              placeholder="Email"
              label="Email"
              type="email"
              name={MEMBER_PROFILE_CREATE.EMAIL_ADDRESS}
              value={values[MEMBER_PROFILE_CREATE.EMAIL_ADDRESS]}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputField
              required
              placeholder="Phone Number"
              label="Phone No."
              type="text"
              name={MEMBER_PROFILE_CREATE.CONTACT_NUMBER}
              value={values[MEMBER_PROFILE_CREATE.CONTACT_NUMBER]}
              onChange={(e) => {
                const { value } = e.target;
                const regex = /^[0-9]*$/;
                if (regex.test(value)) {
                  handleChange(e);
                }
              }}
              inputProps={{ maxLength: 10 }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <InputField
              placeholder="Date of Birth"
              label="Date of Birth"
              type="date"
              name={MEMBER_PROFILE_CREATE.DATE_OF_BIRTH}
              value={values[MEMBER_PROFILE_CREATE.DATE_OF_BIRTH]}
              onChange={handleChange}
              InputProps={{ startAdornment: <></> }}
              disabled={
                !hasPermission(PERMISSIONS.UPDATE_MEMBER_DOB) && !isHelpDesk
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.countryName}
              name={MEMBER_PROFILE_CREATE.NATIONALITY_ID}
              options={getOptions(countries, "countryId")}
              inputProps={{ required: true }}
              error={errors[MEMBER_PROFILE_CREATE.NATIONALITY_ID]}
              value={Number(values[MEMBER_PROFILE_CREATE.NATIONALITY_ID])}
              label="Nationality/Country"
              onChange={(selectedValue) => {
                setFieldValue(
                  MEMBER_PROFILE_CREATE.NATIONALITY_ID,
                  selectedValue?.value ?? ""
                );
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} />
        </Grid>
      </Box>

      {/* ── Section 2: Address ── */}
      <Box style={sectionCard}>
        <div style={sectionTitle}>Address</div>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <InputField
              required
              placeholder="Address"
              label="Address"
              type="text"
              name={MEMBER_PROFILE_CREATE.ADDRESS_LINE_1}
              value={values[MEMBER_PROFILE_CREATE.ADDRESS_LINE_1]}
              onChange={(e) => {
                const { value } = e.target;
                const regex = /^[A-Za-z0-9 ,.\-/]*$/;
                if (regex.test(value)) {
                  if (value.startsWith(" ")) return;
                  if (value.trim().length === 0 && value.length > 0) return;
                  handleChange(e);
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputField
              placeholder="Pincode"
              label="Pincode"
              type="text"
              name={MEMBER_PROFILE_CREATE.PINCODE}
              value={values[MEMBER_PROFILE_CREATE.PINCODE] || ""}
              onChange={(e) => {
                const { value } = e.target;
                const regex = /^[0-9]*$/;
                if (regex.test(value)) {
                  setFieldValue(MEMBER_PROFILE_CREATE.PINCODE, value);
                  handleChange(e);
                }
              }}
              inputProps={{ maxLength: 6 }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.stateName}
              label="State"
              name={MEMBER_PROFILE_CREATE.STATE}
              options={getOptions(states, "stateId")}
              error={errors[MEMBER_PROFILE_CREATE.STATE]}
              value={values[MEMBER_PROFILE_CREATE.STATE]}
              inputProps={{ required: true }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(MEMBER_PROFILE_CREATE.STATE, "");
                  setCities([]);
                } else {
                  setFieldValue(
                    MEMBER_PROFILE_CREATE.STATE,
                    selectedValue.value
                  );
                  setCities(selectedValue.cities);
                }
                setFieldValue(MEMBER_PROFILE_CREATE.CITY, "");
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.cityName}
              label="City"
              name={MEMBER_PROFILE_CREATE.CITY}
              options={getOptions(cities, "cityId")}
              error={errors[MEMBER_PROFILE_CREATE.CITY]}
              value={values[MEMBER_PROFILE_CREATE.CITY]}
              disabled={!values[MEMBER_PROFILE_CREATE.STATE]}
              inputProps={{ required: true }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(MEMBER_PROFILE_CREATE.CITY, "");
                } else {
                  setFieldValue(
                    MEMBER_PROFILE_CREATE.CITY,
                    selectedValue.value
                  );
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} />
          <Grid item xs={12} sm={4} />
        </Grid>
      </Box>

      {/* ── Section 3: Professional & Education ── */}
      <Box style={sectionCard}>
        <div style={sectionTitle}>Professional & Education</div>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <AutoCompleteDropdown
              label="Profession"
              variant="standard"
              value={values[MEMBER_PROFILE_CREATE.PROFESSION]}
              name={MEMBER_PROFILE_CREATE.PROFESSION}
              error={errors[MEMBER_PROFILE_CREATE.PROFESSION]}
              getOptionLabel={(option) => option.profession}
              options={getOptions(profession, "professionsId")}
              onChange={(selectedValue) => {
                setFieldValue(
                  MEMBER_PROFILE_CREATE.PROFESSION,
                  selectedValue?.value ?? ""
                );
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="Division"
              name={MEMBER_PROFILE_CREATE.DIVISION}
              options={getOptions(divisions, "divisionId")}
              error={errors[MEMBER_PROFILE_CREATE.DIVISION]}
              value={values[MEMBER_PROFILE_CREATE.DIVISION]}
              disabled={!isHelpDesk && !isHelpDeskAdmin}
              inputProps={{ required: true }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(MEMBER_PROFILE_CREATE.DIVISION, "");
                  setSubDivisions([]);
                } else {
                  setFieldValue(
                    MEMBER_PROFILE_CREATE.DIVISION,
                    selectedValue.value
                  );
                  setSubDivisions(selectedValue.subDivisions);
                }
                setFieldValue(MEMBER_PROFILE_CREATE.SUB_DIVISION, "");
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="Sub Division"
              name={MEMBER_PROFILE_CREATE.SUB_DIVISION}
              options={getOptions(subDivisions, "divisionId")}
              error={errors[MEMBER_PROFILE_CREATE.SUB_DIVISION]}
              value={values[MEMBER_PROFILE_CREATE.SUB_DIVISION]}
              disabled={!isHelpDesk && !isHelpDeskAdmin}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(MEMBER_PROFILE_CREATE.SUB_DIVISION, "");
                } else {
                  setFieldValue(
                    MEMBER_PROFILE_CREATE.SUB_DIVISION,
                    selectedValue.value
                  );
                }
              }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              name={MEMBER_PROFILE_CREATE.UNIVERSITY_ID}
              options={getOptions(university, "id")}
              error={errors[MEMBER_PROFILE_CREATE.UNIVERSITY_ID]}
              value={Number(values[MEMBER_PROFILE_CREATE.UNIVERSITY_ID])}
              label="University"
              onChange={(selectedValue) => {
                setFieldValue(
                  MEMBER_PROFILE_CREATE.UNIVERSITY_ID,
                  selectedValue?.value ?? ""
                );
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputField
              placeholder="College"
              label="College"
              type="text"
              name={MEMBER_PROFILE_CREATE.COLLEGE}
              value={values[MEMBER_PROFILE_CREATE.COLLEGE]}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputField
              placeholder="Education Qualification"
              label="Education Qualification"
              type="text"
              name={MEMBER_PROFILE_CREATE.EDUCATIONQUALIFICATION}
              value={values[MEMBER_PROFILE_CREATE.EDUCATIONQUALIFICATION]}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <InputField
              placeholder="Company Name"
              label="Company Name"
              type="text"
              name={MEMBER_PROFILE_CREATE.COMPANYNAME}
              value={values[MEMBER_PROFILE_CREATE.COMPANYNAME]}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputField
              placeholder="Occupation"
              label="Occupation"
              type="text"
              name={MEMBER_PROFILE_CREATE.OCCUPATION}
              value={values[MEMBER_PROFILE_CREATE.OCCUPATION]}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputField
              placeholder="Designation"
              label="Designation"
              type="text"
              name={MEMBER_PROFILE_CREATE.DESIGNATION}
              value={values[MEMBER_PROFILE_CREATE.DESIGNATION]}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Box>

      {/* ── Section 4: Introducer Details ── */}
      <Box style={sectionCard}>
        <div style={sectionTitle}>Introducer Details</div>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <InputField
              required
              placeholder="Introducer's Name"
              label="Introducer's Name"
              type="text"
              name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME}
              value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME] || ""}
              onChange={(e) => {
                const { value } = e.target;
                const regex = /^[A-Za-z ]*$/;
                if (regex.test(value)) {
                  if (value.startsWith(" ")) return;
                  if (value.trim().length === 0 && value.length > 0) return;
                  setFieldValue(
                    MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME,
                    value
                  );
                  handleChange(e);
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputField
              required
              placeholder="Introducer's Contact Number"
              label="Introducer's Contact Number"
              type="text"
              name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER}
              value={
                values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER] || ""
              }
              onChange={(e) => {
                const { value } = e.target;
                const regex = /^[0-9]*$/;
                if (regex.test(value)) {
                  setFieldValue(
                    MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER,
                    value
                  );
                  handleChange(e);
                }
              }}
              inputProps={{ maxLength: 10 }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputField
              placeholder="Introducer's Email"
              label="Introducer's Email"
              type="email"
              name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL}
              value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL]}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputField
              placeholder="Remark"
              label="Remark"
              type="text"
              name={MEMBER_PROFILE_CREATE.REMARK}
              value={values[MEMBER_PROFILE_CREATE.REMARK]}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4} />
          <Grid item xs={12} sm={4} />
        </Grid>
      </Box>

      {/* ── Section 5: Organization Structure ── */}
      <Box style={sectionCard}>
        <div style={sectionTitle}>Organization Structure</div>
        {/* Org Structure — 7 fields ek line mein */}
        <Grid container spacing={1.5}>
          {[
            { label: "Area", name: MEMBER_PROFILE_CREATE.AREA_NAME },
            { label: "Cluster", name: MEMBER_PROFILE_CREATE.CLUSTER_NAME },
            { label: "Zone", name: MEMBER_PROFILE_CREATE.ZONE_NAME },
            { label: "Region", name: MEMBER_PROFILE_CREATE.REGION_NAME },
            { label: "Chapter", name: MEMBER_PROFILE_CREATE.CHAPTER_NAME },
            { label: "District", name: MEMBER_PROFILE_CREATE.DISTRICT_NAME },
          ].map((field) => (
            <Grid
              item
              key={field.name}
              sx={{ flexBasis: "14.28%", maxWidth: "14.28%", flexGrow: 0 }}
            >
              <InputField
                label={field.label}
                placeholder={field.label}
                name={field.name}
                value={values[field.name]}
                onChange={handleChange}
                disabled={!isHelpDesk || !isHelpDeskAdmin}
              />
            </Grid>
          ))}

          {/* Block — 7th field */}
          <Grid
            item
            sx={{ flexBasis: "14.28%", maxWidth: "14.28%", flexGrow: 0 }}
          >
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              name={MEMBER_PROFILE_CREATE.BLOCK}
              options={getOptions(block, "structureId")}
              inputProps={{ required: true }}
              error={errors[MEMBER_PROFILE_CREATE.BLOCK]}
              value={Number(values[MEMBER_PROFILE_CREATE.BLOCK])}
              label="Block"
              disabled={
                !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
              }
              onChange={(selectedValue) => {
                setFieldValue(
                  MEMBER_PROFILE_CREATE.BLOCK,
                  selectedValue?.value ?? ""
                );
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {/* ── Action Buttons ── */}
      <Box sx={{ display: "flex", gap: "12px", padding: "4px 0 12px" }}>
        <Button
          isLoading={isLoading}
          type="submit"
          label="Save Changes"
          style={{ minWidth: "150px" }}
        />
        <Button
          label="Cancel"
          variant="outlined"
          style={{ minWidth: "140px" }}
          onClick={onCancel}
        />
      </Box>
    </Box>
  );
}

function MemberProfileForm({ isEdit = false }) {
  const [countries, setCountries] = useState([]);
  const [isNameChangeRestricted, setIsNameChangeRestricted] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [showToast, setShowToast] = useState(null);
  const { id } = useParams();
  const memberProfile = useSelector(selectMemberProfile);
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const toast = useContext(ToastAlertContext);
  // eslint-disable-next-line no-unused-vars
  const [memberInfo, setMemberInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [university, setUniversity] = useState([]);
  const [profession, setProfession] = useState([]);
  const [block, setBlock] = useState([]);
  const { isDistrictSi, isChapterSi, isRegionSi, isHelpDesk, isHelpDeskAdmin } =
    useSelector(selectAllSIUsers);
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);

  const hasPermission = useUserConfig();
  const getSafeNumber = (value) =>
    value !== null && value !== undefined && value !== "" ? Number(value) : "";

  const profileData = memberInfo?.memberId ? memberInfo : memberProfile;

  const getStates = async (profile = profileData) => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);

    if (profile?.state) {
      const selectedState = response?.data?.find(
        (state) => Number(profile.state) === state.stateId
      );
      setCities(selectedState?.cities || []);
    } else {
      setCities([]);
    }
  };

  const getDivisions = async (profile = profileData) => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);

    if (profile?.divisionId) {
      const selectedValue = response?.data?.find(
        (division) => Number(profile.divisionId) === division.divisionId
      );
      setSubDivisions(selectedValue?.subDivisions || []);
    } else {
      setSubDivisions([]);
    }
  };

  const getCountries = async () => {
    const response = await IntroductionFormApi.getCountries();
    setCountries(response.data);
  };

  const getUniversity = async () => {
    const response = await IntroductionFormApi.getUniversity();
    setUniversity(response.data);
  };

  const getProfessions = async () => {
    const response = await IntroductionFormApi.getProfessions();
    setProfession(response.data);
  };

  const getAllBlocks = async (profile = profileData) => {
    if (profile?.districtId) {
      const response = await IntroductionFormApi.getBlocks({
        districtId: profile.districtId,
      });
      setBlock(response.data);
    } else {
      setBlock([]);
    }
  };

  const getMemberDetails = async () => {
    try {
      const response = await Member.getMemberDetailsById(Number(id));
      const memberData = response?.data?.data || response?.data || {};

      setMemberInfo(memberData);
      setIsNameChangeRestricted(memberData?.isActiveContribution === true);

      await getStates(memberData);
      await getDivisions(memberData);
      await getAllBlocks(memberData);
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  // const handleModalOpen = () => {
  //   setModalOpen(true);
  // };

  const handleModalClose = () => {
    setModalOpen((prev) => !prev);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const handleImageUpload = async () => {
    try {
      if (selectedImage) {
        const file = new File([selectedImage], "image.jpg", {
          type: "image/jpeg",
        });
        const formData = new FormData();
        formData.append("file", file);
        setIsLoading(true);
        await Member.uploadProfilePhoto({
          memberId: Number(id),
          data: formData,
        });
        setMemberInfo((prevMemberInfo) => ({
          ...prevMemberInfo,
          profilePhotoUrl: URL.createObjectURL(selectedImage),
        }));
        toast.show("Image Uploaded Successfully", AlertStatus.SUCCESS);
        setTimeout(() => {
          setModalOpen(false);
        }, 2000);
      }
      setIsLoading(false);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCountries();
    getUniversity();
    getProfessions();
    getMemberDetails();
  }, [id]);

  const onFormSubmit = async (values) => {
    try {
      setIsLoading(true);
      await Member.memberUpdate({ memberId: Number(id), ...values });
      setTimeout(() => {
        navigate(-2);
      }, 2000);
      setShowToast({
        message: isEdit
          ? "Member Updated Successfully"
          : "Member Created Successfully",
        severity: "success",
      });
      setIsLoading(false);
    } catch (error) {
      setShowToast({
        message: error.message ?? "something went wrong, try again",
        severity: "error",
      });
      setIsLoading(false);
      Sentry.captureException(error);
    }
  };

  return (
    <div>
      {/* ── Page Header ── */}
      <Box style={Styles.headerContainer}>
        <Box
          style={{
            ...Styles.headerHeading,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          {/* "Edit Profile" heading hidden — space used by Alert below */}
          {/* {isEdit ? "Edit Profile" : "Add a Profile"} */}
          {isNameChangeRestricted && (
            <Alert severity="error">
              <Box>
                Name can&rsquo;t be changed if contribution has been made in the
                current financial year. Contact Region Stats to update member
                name.
              </Box>
            </Alert>
          )}
        </Box>

        {/* Profile photo section commented out — space reclaimed by form */}
        {/*
        <Box style={{ display: "flex", alignItems: "center" }}>
          <Box style={Styles.imageView}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              {memberInfo.profilePhotoUrl ? (
                <img
                  src={memberInfo.profilePhotoUrl}
                  alt="Profile"
                  style={Styles.profileImage}
                />
              ) : (
                <div>{getInitials(memberInfo.fullName)}</div>
              )}
            </div>
          </Box>
        </Box>
        */}
      </Box>

      {/* ── Form ── */}
      <Box style={{ width: "95%", margin: "auto" }}>
        <div style={Styles.card}>
          <Formik
            enableReinitialize
            initialValues={{
              [MEMBER_PROFILE_CREATE.NAME]: profileData?.fullName || "",
              [MEMBER_PROFILE_CREATE.EMAIL_ADDRESS]: profileData?.emailId || "",
              [MEMBER_PROFILE_CREATE.CONTACT_NUMBER]:
                profileData?.mobileNumber || "",
              [MEMBER_PROFILE_CREATE.DATE_OF_BIRTH]:
                profileData?.dateOfBirth || "",
              [MEMBER_PROFILE_CREATE.NATIONALITY_ID]: getSafeNumber(
                profileData?.nationalityId
              ),
              [MEMBER_PROFILE_CREATE.ADDRESS_LINE_1]:
                profileData?.addressLine1 || "",
              [MEMBER_PROFILE_CREATE.STATE]: getSafeNumber(profileData?.state),
              [MEMBER_PROFILE_CREATE.CITY]: getSafeNumber(profileData?.city),
              [MEMBER_PROFILE_CREATE.PINCODE]: profileData?.pincode || "",
              [MEMBER_PROFILE_CREATE.PROFESSION]: profileData?.profession || "",
              [MEMBER_PROFILE_CREATE.PROFESSIONAL_SERVICE]:
                profileData?.professionalServiceGroup || "",
              [MEMBER_PROFILE_CREATE.UNIVERSITY_ID]: getSafeNumber(
                profileData?.universityId
              ),
              [MEMBER_PROFILE_CREATE.COLLEGE]: profileData?.collegeName || "",
              [MEMBER_PROFILE_CREATE.EDUCATIONQUALIFICATION]:
                profileData?.educationalQualification || "",
              [MEMBER_PROFILE_CREATE.COMPANYNAME]:
                profileData?.companyName || "",
              [MEMBER_PROFILE_CREATE.OCCUPATION]: profileData?.occupation || "",
              [MEMBER_PROFILE_CREATE.DESIGNATION]:
                profileData?.designation || "",
              [MEMBER_PROFILE_CREATE.DIVISION]: getSafeNumber(
                profileData?.divisionId
              ),
              [MEMBER_PROFILE_CREATE.SUB_DIVISION]: getSafeNumber(
                profileData?.subdivisionId
              ),
              [MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME]:
                profileData?.introducerName || "",
              [MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER]:
                profileData?.introducerMobileNumber || "",
              [MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL]:
                profileData?.introducerEmail || "",
              [MEMBER_PROFILE_CREATE.AREA_NAME]: profileData?.areaName || "",
              [MEMBER_PROFILE_CREATE.CLUSTER_NAME]:
                profileData?.clusterName || "",
              [MEMBER_PROFILE_CREATE.ZONE_NAME]: profileData?.zoneName || "",
              [MEMBER_PROFILE_CREATE.REGION_NAME]:
                profileData?.regionName || "",
              [MEMBER_PROFILE_CREATE.CHAPTER_NAME]:
                profileData?.chapterName || "",
              [MEMBER_PROFILE_CREATE.DISTRICT_NAME]:
                profileData?.districtName || "",
              [MEMBER_PROFILE_CREATE.BLOCK]: getSafeNumber(
                profileData?.blockId
              ),
              [MEMBER_PROFILE_CREATE.REMARK]: profileData?.remark || "",
            }}
            onSubmit={debounce(onFormSubmit)}
          >
            {({
              values,
              handleChange,
              errors,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <ProfileForm
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  handleSubmit={handleSubmit}
                  setFieldValue={setFieldValue}
                  setCities={setCities}
                  states={states}
                  cities={cities}
                  countries={countries}
                  university={university}
                  profession={profession}
                  memberProfile={memberProfile}
                  block={block}
                  hasPermission={hasPermission}
                  isLoading={isLoading}
                  isDistrictSi={isDistrictSi}
                  isChapterSi={isChapterSi}
                  isRegionSi={isRegionSi}
                  isHelpDesk={isHelpDesk}
                  isHelpDeskAdmin={isHelpDeskAdmin}
                  divisions={divisions}
                  subDivisions={subDivisions}
                  setSubDivisions={setSubDivisions}
                  isNameChangeRestricted={isNameChangeRestricted}
                />
              </form>
            )}
          </Formik>
        </div>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
        <ProfilePictureModal
          open={modalOpen}
          onClose={handleModalClose}
          handleImageChange={handleImageChange}
          handleImageUpload={handleImageUpload}
          memberProfile={memberProfile}
          isLoading={isLoading}
          toast={toast}
        />
      </Box>
    </div>
  );
}

export default MemberProfileForm;
